module.exports = __webpack_public_path__ + "img/左右收起.376ea24d.svg";